import React, { useState } from "react";
import { Form, Alert } from "antd";
import RangerLayout from "layouts/RangerLayout/RangerLayout";
import StyledButton from "components/button/Button";
import Input from "components/input/Input";
import EnumSelect from "components/enumselect/EnumSelect";

const Register = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);

  const gender = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const region = [
    { label: "Region 1", value: "region1" },
    { label: "Region 2", value: "region2" },
  ];

  const province = [
    { label: "Province 1", value: "province1" },
    { label: "Province 2", value: "province2" },
  ];

  const municipality = [
    { label: "Municipality 1", value: "municipality1" },
    { label: "Municipality 2", value: "municipality2" },
  ];

  const barangay = [
    { label: "Barangay 1", value: "barangay1" },
    { label: "Barangay 2", value: "barangay2" },
  ];

  const onFinish = async (values) => {
    setLoading(true);
    setError("");
    setTimeout(() => {
      setLoading(false);
      if (values.username === "ranger" && values.password === "password") {
        window.location.href = "/";
      } else {
        setError("Invalid username or password");
      }
    }, 1000);
  };

  return (
    <RangerLayout title="New Farm Ranger">
      <div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}
        >
          <Input
            label="First Name"
            name="first_name"
            required
          />
          
          <Input
            label="Middle Name"
            name="middle_name"
            required
          />
          
          <Input
            label="Last Name"
            name="last_name"
            required
          />
          
          <Input
            label="Ext. (I, II, III, Sr., Jr.)"
            name="name_extension"
          />
          
          <Input
            label="Contact No."
            name="contact_no"
          />

          <EnumSelect
            label="Region"
            name="region"
            options={region}
          />

          <EnumSelect
            label="Province"
            name="province"
            options={province}
          />

          <EnumSelect
            label="Municipality"
            name="municipality"
            options={municipality}
          />

          <EnumSelect
            label="Barangay"
            name="barangay"
            options={barangay}
          />

          <Input
            label="Email"
            name="email"
            required
            type="email"
          />
          
          <Input
            label="Password"
            name="password"
            required
            type="password"
            rules={[
              {
                validator: async (_, value) => {
                  if (!value) return;
                  if (value.length < 8) {
                    throw new Error('Password must be at least 8 characters long');
                  }
                  if (!/[A-Z]/.test(value)) {
                    throw new Error('Password must contain at least one uppercase letter');
                  }
                  if (!/[a-z]/.test(value)) {
                    throw new Error('Password must contain at least one lowercase letter');
                  }
                  if (!/[0-9]/.test(value)) {
                    throw new Error('Password must contain at least one number');
                  }
                  if (!/[!@#$%^&*]/.test(value)) {
                    throw new Error('Password must contain at least one special character (!@#$%^&*)');
                  }
                }
              }
            ]}
          />
          
          <Input
            label="Confirm Password"
            name="confirm_password"
            required
            type="password"
            rules={[
              {
                validator: async (_, value) => {
                  if (!value) {
                    throw new Error('Please confirm your password!');
                  }
                  const password = form.getFieldValue('password');
                  if (password !== value) {
                    throw new Error('The two passwords do not match!');
                  }
                }
              }
            ]}
          />

          {error && (
            <Form.Item>
              <Alert message={error} type="error" showIcon closable onClose={() => setError("")} />
            </Form.Item>
          )}
          <Form.Item>
            <StyledButton
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              Back
            </StyledButton>
          </Form.Item>
          <Form.Item>
            <StyledButton
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              Submit
            </StyledButton>
          </Form.Item>
        </Form>
      </div>
    </RangerLayout>
  );
};

export default Register;
